import District from './District';

class School {
	id: number;
	rspo: number;
	name: string;
	city: string;
	country: string;
	zipCode: string;
	street: string;
	building: string;
	apartment: string;
	wojewodztwo: string;
	powiat: string;
	district: District;
	olympicsId: number;

	constructor(
		id: number,
		rspo: number,
		name: string,
		city: string,
		country: string,
		zipCode: string,
		street: string,
		building: string,
		apartment: string,
		wojewodztwo: string,
		powiat: string,
		district: District,
		olympicsId: number = 0,
	) {
		this.id = id;
		this.rspo = rspo;
		this.name = name;
		this.city = city;
		this.country = country;
		this.zipCode = zipCode;
		this.street = street;
		this.building = building;
		this.apartment = apartment;
		this.wojewodztwo = wojewodztwo;
		this.powiat = powiat;
		this.district = district;
		this.olympicsId = olympicsId;
	}

	public get cityWithCountry() {
		if (!this.country || this.country.trim() === '') {
			return this.city;
		}
		return this.city && this.city.trim() !== '' ? `${this.country}: ${this.city}` : this.country;
	}

	public static fromApiResponse(data: any) {
		return new School(
			data.id ? data.id : 0,
			data.rspo ? data.rspo : -1,
			data.name ? data.name : '',
			data.city ? data.city : '',
			data.country ? data.country : '',
			data.zip_code ? data.zip_code : '',
			data.street ? data.street : '',
			data.building ? data.building : '',
			data.apartment ? data.apartment : '',
			data.wojewodztwo ? String(data.wojewodztwo) : '',
			data.powiat ? String(data.powiat) : '',
			District.fromApiResponse(data.district ? data.district : {}),
			data.olympics_id ? Number(data.olympics_id) : 0,
		);
	}

	public static createEmpty = () => {
		return new School(-1, 0, '', '', '', '', '', '', '', '', '', { id: -1, name: '' }, 0);
	};
}

export default School;
